import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { TextButton } from '../../../components/button';
import { useUser } from '../../../user/useUser';

type Props = {
  list: Array<any>;
  limit: number;
  children: (array: Array<any>) => ReactNode;
  source: string;
};

export const EntityRestrictedList: FC<Props> = ({
  list,
  limit,
  children,
  source,
}) => {
  const { loggedIn } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  if (loggedIn || limit >= list.length) {
    return <>{children(list)}</>;
  }
  const newList = list.slice(0, limit);
  return (
    <>
      {children(newList)}
      <TextButton
        onClick={() => openRestrictedModal({ source: `${source}_see_more` })}
        iconRight="keyboard_arrow_down"
      >
        <FormattedMessage
          id="entity/expertises/RestrictedList.tsx/1"
          values={{ number: list.length - limit }}
        />
      </TextButton>
    </>
  );
};
